module.exports = __webpack_public_path__ + "212b05a8b4371791789c1831da8775ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-cleats-s.png
// module id = 1921
// module chunks = 0